import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../../util/app";
/**
 *
 * @param {any} item object containing health blood
 */
function AssessmentDetail({ item }) {
    return (
        <div className="row m-b-20">
            <div className="col-4 bg-primary pl-4">
                <h5>Detail</h5>
            </div>
            <div className="col-md-12">
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td>
                                <strong>Date & Time</strong>
                            </td>
                            <td>{cleanDate(item.created_at)}</td>
                        </tr>
                        {item.score.desc !== "nil" && (
                            <tr>
                                <td>
                                    <strong>Result</strong>
                                </td>
                                <td>
                                    <span className="badge badge-primary">
                                        Score:
                                        {item.score.value}
                                    </span>{" "}
                                    <br /> {item.score.desc}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>
                                <strong>Confirmation</strong>
                            </td>
                            <td>
                                {item.confirm ? <span className="badge badge-success">Confirmed</span> : <span className="badge badge-danger">Unconfirmed</span>}
                                {item.confirm && (
                                    <p className="text-muted">
                                        <TimeAgo date={item.confirm.datetime} />
                                    </p>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <strong>Staff</strong>
                            </td>
                            <td>
                                <StaffProfileCard item={item.author} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-md-12">
                <div className="row">
                    <div className="col-4 bg-primary pl-4">
                        <h5>Additional Information</h5>
                    </div>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            {item.additional &&
                                item.additional.map((a, i) => (
                                    <tr key={i} className="col-md-6 fade-in">
                                        <td style={{ width: "40%" }}>
                                            <strong>{a.key}</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <span className="text-primary">{a.value}</span>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="col-md-12">
                <div className="row">
                    <div className="col-4 bg-primary pl-4">
                        <h5>Questions and Selected Options</h5>
                    </div>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            {item.questions &&
                                item.questions.map((a, i) => (
                                    <tr key={i} className="col-md-6 fade-in m-b-10">
                                        <td style={{ width: "40%" }}>
                                            <strong className="m-r-10">{i + 1}.</strong> {a.question.name}
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            {a.options.map((opt, iw) => (
                                                <p
                                                    style={{
                                                        marginRight: "4px",
                                                    }}
                                                    className="text-primary"
                                                    key={opt.id}
                                                >
                                                    {opt.name}
                                                </p>
                                            ))}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default AssessmentDetail;
